import DeleteFeature from './DeleteFeature';

export default DeleteFeature;
